export default function PeriodsController(
    resourceDependencies,
    $scope,
    $rootScope,
    searchBarFactory,
    houseService,
    searchService,
    Basket,
    siteService,
    $timeout,
    moment,
    searchUrl,
    siteTitleFactory,
    SearchPrioritizeFactory,
    DummyApi,
    Scroll
) {
    $scope.prioLane = {
        details: null,
        timeSlots: null,
    };

    searchUrl.init().then((res) => {
        $scope.searchCrit = res;
        $scope.activity = res.activity;
        $scope.location = res.location;
        $scope.date = res.date;

        $scope.prioLane.details = {
            activityItemName: res.activity.ItemName, // "bane / baner"
            image: res.activity.ThumbURL,
            images: null,
            name: "Prioriterede baner",
            LaneID: 0,
        };
    });

    $scope.selectedBookings = Basket.currentBookings;

    $scope.showAlreadyReserved = true;

    $scope.resourceDependencies = resourceDependencies;

    $scope.searchBarOnly = true;

    /**************************************
     * BROADCAST RECIEVER
     **************************************/
    // When user clicks Search in searchbar -> Recieve Broadcast from Searchbar.js -> houseService
    var searchNowEventListener = $scope.$on(
        "search-now-broadcast",
        function () {
            search();
        }
    );
    $scope.$on("$destroy", searchNowEventListener);

    var UITooltipEventListener = $rootScope.$on(
        "show-UI-Tooltip-preventWideSearch",
        function () {
            // avail param : event
            $scope.searchBarOnly = true;
        }
    );
    $scope.$on("$destroy", UITooltipEventListener);

    var nextResultsEventListener = $rootScope.$on(
        "next-results-update-broadcast",
        function () {
            // avail param : event
            // $scope.newSearchResultFromApi(houses);
        }
    );
    $scope.$on("$destroy", nextResultsEventListener);

    /*******************************
     *  Scroll Functions
     *******************************/

    // When user clicks Search in searchbar -> Recieve Broadcast from Searchbar.js -> houseService
    var scrollEventListener = $scope.$on(
        "scroll-to-elem-broadcast",
        function (broadcastObj, elemId, offset) {
            $scope.ScrollToResults(elemId, offset);
        }
    );
    $scope.$on("$destroy", scrollEventListener);

    $scope.ScrollToResults = function (elemID, offset) {
        Scroll.to(elemID, offset);
    };

    $scope.shouldPageScrollToResults = function () {
        if (siteService.scrollToSearchResults) {
            var offset = siteService.headerHeight + 15;

            Scroll.to("title-focus", offset);

            siteService.scrollToSearchResults = false;
        }
    };

    /****************************************
     *
     * SEARCH
     *
     */

    function search() {
        if (
            houseService.searchFilter.houseCategory.CategoryID == 0 &&
            houseService.searchFilter.houseType.ID == -1
        ) {
            $timeout(function () {
                $rootScope.$broadcast("show-UI-Tooltip-preventWideSearch");
            }, 500);

            return false;
        }

        // Format startDate2
        houseService.searchFilter.startDateDayOfWeek = moment(
            houseService.searchFilter.startDate,
            "DD-MM-YYYY"
        ).toDate();

        if (DummyApi.isEnabled()) {
            let items = DummyApi.getSearchPeriods(); // getSearchResult

            $scope.searchBarOnly = false;

            $scope.newSearchResultFromApi(items);
        } else {
            searchService.getPeriods().then(function (items) {
                $scope.searchBarOnly = false;

                $scope.newSearchResultFromApi(items);
            });
        }
    }

    /**
     * Handle search response
     */
    $scope.newSearchResultFromApi = function (houses) {
        // $timeout(() => {
        siteTitleFactory.setForSearch(houses);

        SearchPrioritizeFactory.findPrioritizedLanes(angular.copy(houses)).then(
            (res) => {
                if (res.length) {
                    $scope.prioLane.timeSlots = res;

                    /**  add first available laneId to display Praktisk Info (devops issue 820)*/
                    var { _LaneID, _FromPrice, _House } = res[0].periods[0];

                    /* add necesary props for lane details */
                    $scope.prioLane.details = {
                        ...$scope.prioLane.details,
                        LaneID: _LaneID,
                        FromPrice: _FromPrice,
                        House: _House,
                    };
                }
            }
        );

        // Merge lanes into first parent
        let lanes = [];
        houses.ParentLanes.map((pLane) => {
            lanes = [...lanes, ...pLane.Lanes];
        });

        if (houses.ParentLanes.length) {
            houses.ParentLanes[0].Lanes = lanes;

            // Clear other parent lanes
            houses.ParentLanes = [houses.ParentLanes[0]];
        }

        $scope.searchResults = houseService.searchResults = houses;

        // Viewtype defines the search view type // activities, locations or periods
        houseService.viewType = houses.ViewType;

        // Update var to deliver selected time to search-filter
        houseService.searchFilter.selectedTimeObj =
            searchBarFactory.selectedTimeObj;

        // pagescroll handler
        $scope.shouldPageScrollToResults();
        // });
    };

    /**
     * TOOLTIP - Repeatable Pattern Detected!
     */
    $scope.showRepeatableBookingTooltip = false;

    $scope.dismissRepeatableBookingTooltip = function () {
        $scope.showRepeatableBookingTooltip = false;
    };
}
